import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 195203 163930"
    {...props}
  >
    <path
      d="M139840 6685c-18079 0-33842 10787-42239 26794C89208 17472 73442 6685 55363 6685c-26885 0-48678 23839-48678 53250 0 47854 90916 96417 90916 96417s90917-48563 90917-96417c0-29411-21793-53250-48678-53250z"
      style={{
        fill: "none",
        stroke: "#000",
        strokeWidth: 13370.1,
      }}
      className="stroke1"
    />
  </svg>
)
export default SvgComponent
